<template>
    <span>
        <v-layout align-center>
            <span v-if="token && $utils.isNotMobile()" class="pl-3 pr-1" style="color: #fff">
                {{ profile.name }}
            </span>
            <v-menu v-if="token" :close-on-content-click=true :nudge-width="200" offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn dark icon v-on="on">
                        <v-icon>person</v-icon>
                    </v-btn>
                </template>
                <v-card>
                    <v-list>
                        <v-list-tile avatar>
                            <v-list-tile-avatar>
                                <v-icon size="30">person</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title class="username">{{ profile.name }}</v-list-tile-title>
                                <v-list-tile-sub-title>
                                    <a :href="openid_url" target="_blank" rel="noopener noreferrer" class="userlink">
                                        {{ profile.email }}
                                    </a>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                    <v-divider></v-divider>
                    <template v-if="appEnv !== $const.env.PRO">
                        <div class="pl-1">
                            <table class="build-info">
                                <tr>
                                    <td>Env</td>
                                    <td>{{appEnv}}</td>
                                </tr>
                                <tr>
                                    <td>Version</td>
                                    <td>{{appVersion}}</td>
                                </tr>
                                <tr>
                                    <td>Build</td>
                                    <td>{{buildTime}}</td>
                                </tr>
                            </table>
                        </div>
                        <v-divider></v-divider>
                    </template>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @click="signOut">{{$t('signOut')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>
        </v-layout>
    </span>
</template>
<script>
import { mapState } from 'vuex'

export default {
    name: 'UserMenu',
    data () {
        return {
            openid_url: '',
            appEnv: process.env.NODE_ENV,
            buildTime: new Date(Number(process.env.VUE_APP_BUILD_TIME)).toLocaleString()
        }
    },
    computed: {
        ...mapState({
            profile: state => state.auth.profile,
            token: state => state.auth.token,
            appVersion: state => state.version,
            buildVersion: state => state.buildVersion
        })
    },
    mounted () {
        this.openid_url = process.env.VUE_APP_OPENID_URL
        if (this.$store.getters.token) {
            this.$store.dispatch(this.$actionTypes.auth.GET_PROFILE)
        }
    },
    methods: {
        signOut () {
            this.$store.dispatch(this.$actionTypes.auth.SIGN_OUT)
        }
    }
}
</script>
<style scoped>
    .username {
        font-weight: bold;
    }

    .userlink {
        color: #649FDF;
        text-decoration: none;
    }

    table.build-info tr td:first-child {
        font-weight: bold;
        padding-right: 5px;
    }
</style>
